import React from 'react';
import Footer from '../MainLandingPage/components/Footer/Footer';

const FooterComponent = () => {
  return <Footer />;
};

export default FooterComponent;
